import { Tag } from 'antd';
import { cn } from 'technical/tailwind/cn';
import { useTranslation } from 'translations/hooks';

export const SynchronizationTag = ({ isSynced }: { isSynced: boolean }) => {
  const { t } = useTranslation();

  const statusClasses = {
    SYNCED: 'bg-purple-100 border-purple-200 text-purple-700',
    UNSYNCED: 'bg-gray-100 border-gray-300 text-gray-500',
  };

  return (
    <Tag
      variant="outlined"
      className={cn(
        'flex w-fit items-center gap-1 rounded-full',
        statusClasses[isSynced ? 'SYNCED' : 'UNSYNCED'],
      )}
    >
      <span className="leading-none">&#x25CF;</span>
      {isSynced
        ? t('tunnel.synchronizationDrawer.status.synced')
        : t('tunnel.synchronizationDrawer.status.unsynced')}
    </Tag>
  );
};
